import {
  KNM_ACT,
  KNM_APPROVE_INFO,
  KNM_CHECKLIST_INFO,
  KNM_DOCUMENTS,
  KNM_EPGU_NOTIFICATION,
  KNM_EVENT_SUBJECT,
  KNM_EXECUTION_HISTORY,
  KNM_HISTORY,
  KNM_INFO,
  KNM_OBJECTS_INFO,
  KNM_OTHER_INFO,
  KNM_PREVIOUS,
  KNM_RESULT_DECISIONS,
  KNM_SIGN_INFO,
  KNM_STATUS_EXCHANGE,
  KNM_VERIFIED_PERSON,
  KNM_PLAN_HISTORY,
  KNM_PLAN_HISTORY_CHANGES,
  KNM_NOTIFICATION,
  KNM_JUDGMENTS,
  AGREEMENTS,
  REPEAT_PASSPORTS,
} from 'CorePackage/MainModule/routes/routes';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';

import { ErknmMenuItemsIdsEnum } from '../enums/ErknmMenuItemsIdsEnum';
import { IKnmErknmMenuItem } from '../interfaces/IKnmErknmMenuItem';
import { insertItemAfterIdInPlace } from './insertItemAfterIdInPlace';

export const basicErknmMenuItems = (
  created: string | null | undefined,
  settings: IAdminSetting[] | undefined,
): IKnmErknmMenuItem[] => {
  const agreementsStartFrom = settings?.find(
    x => x.code === AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM,
  )?.value;
  const repeatPassportsStartFrom = settings?.find(
    x => x.code === AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM,
  )?.value;

  const isEnablePaperlessDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );

  const isEnableAgreements =
    Boolean(agreementsStartFrom) &&
    isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM);
  const isEnablePrescriptionCheck =
    Boolean(repeatPassportsStartFrom) &&
    isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM);

  const items = [
    {
      id: ErknmMenuItemsIdsEnum.KNM_INFO,
      route: `#${KNM_INFO}`,
      title: 'Общие сведения о КНМ',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_APPROVE_INFO,
      route: `#${KNM_APPROVE_INFO}`,
      title: 'Сведения о согласовании',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_OBJECTS_INFO,
      route: `#${KNM_OBJECTS_INFO}`,
      title: 'Сведения об объектах контроля',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_VERIFIED_PERSON,
      route: `#${KNM_VERIFIED_PERSON}`,
      title: 'Сведения о контролируемом лице',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_CHECKLIST_INFO,
      route: `#${KNM_CHECKLIST_INFO}`,
      title: 'Перечень действий',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_EVENT_SUBJECT,
      route: `#${KNM_EVENT_SUBJECT}`,
      title: 'Предмет КНМ',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_NOTIFICATION,
      route: `#${KNM_NOTIFICATION}`,
      title: isEnablePaperlessDocument ? 'Уведомление о решении' : 'Информация об уведомлении',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_OTHER_INFO,
      route: `#${KNM_OTHER_INFO}`,
      title: 'Иная информация',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_ACT,
      route: `#${KNM_ACT}`,
      title: 'Сведения об акте',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_RESULT_DECISIONS,
      route: `#${KNM_RESULT_DECISIONS}`,
      title: 'Сведения о решениях',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_JUDGMENTS,
      route: `#${KNM_JUDGMENTS}`,
      title: 'Сведения о судебных решениях',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_DOCUMENTS,
      route: `#${KNM_DOCUMENTS}`,
      title: 'Документы',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_SIGN_INFO,
      route: `#${KNM_SIGN_INFO}`,
      title: 'Сведения о подписании',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_EPGU_NOTIFICATION,
      route: `#${KNM_EPGU_NOTIFICATION}`,
      title: 'Сведения об информировании контролируемого лица в ЕПГУ',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_PREVIOUS,
      route: `#${KNM_PREVIOUS}`,
      title: 'Предыдущие КНМ',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_STATUS_EXCHANGE,
      route: `#${KNM_STATUS_EXCHANGE}`,
      title: 'Статус обмена с АИК "Надзор-Web"',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_HISTORY,
      route: `#${KNM_HISTORY}`,
      title: 'История изменений',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_EXECUTION_HISTORY,
      route: `#${KNM_EXECUTION_HISTORY}`,
      title: 'История проведения КНМ',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_PLAN_HISTORY,
      route: `#${KNM_PLAN_HISTORY}`,
      title: 'История согласования плана',
    },
    {
      id: ErknmMenuItemsIdsEnum.KNM_PLAN_HISTORY_CHANGES,
      route: `#${KNM_PLAN_HISTORY_CHANGES}`,
      title: 'История изменений плана',
    },
  ];

  if (isEnableAgreements) {
    insertItemAfterIdInPlace<IKnmErknmMenuItem>(items, ErknmMenuItemsIdsEnum.KNM_RESULT_DECISIONS, {
      id: ErknmMenuItemsIdsEnum.KNM_AGREEMENTS,
      route: `#${AGREEMENTS}`,
      title: 'Сведения о соглашениях',
    });
  }

  if (isEnablePrescriptionCheck) {
    insertItemAfterIdInPlace<IKnmErknmMenuItem>(items, ErknmMenuItemsIdsEnum.KNM_STATUS_EXCHANGE, {
      id: ErknmMenuItemsIdsEnum.KNM_REPEAT_PASSPORTS,
      route: `#${REPEAT_PASSPORTS}`,
      title: 'Перечень повторных мероприятий',
    });
  }

  return items;
};
